import React from 'react';
import PropTypes from 'prop-types';

const listaTipo = [
    { value: 'ACAO', nome: 'Ação' },
    { value: 'OPCAO', nome: 'Opção' },
    { value: 'FII', nome: 'Fundos de Investimento' },
    { value: 'TDIR', nome: 'Tesouro Direto' },
    { value: 'RFIXA', nome: 'Renda Fixa' },
];

const AtivosForm = (props) => {
    return (
        <div className="row">
            <div className="form-group col-4">
                <input type="text" placeholder="Ativo..." className="form-control"
                    value={props.ativo.nome} autoFocus
                    onChange={evt => props.handleChangeNome(evt)} />
            </div>
            <div className="form-group col-3">
                <select className="form-control" value={props.ativo.tipo} onChange={props.handleChangeTipo}>
                    {listaTipo.map(item => <option key={item.value} value={item.value}>{item.nome}</option>)}
                </select>
            </div>
            <div className="form-group col-3">
                <input type="text" placeholder="Código..." className="form-control"
                    value={props.ativo.api_id}
                    onChange={evt => props.handleChangeApi(evt)} />
            </div>
            <div className="form-group col-2">
                <button type="button" className="btn btn-primary btn-block"
                    onClick={props.handleSave} >
                    <i className="far fa-save" />
                </button>
            </div>
        </div>
    );
};

AtivosForm.propTypes = {
    handleSave: PropTypes.func.isRequired,
    handleChangeNome: PropTypes.func.isRequired,
    handleChangeTipo: PropTypes.func.isRequired,
    handleChangeApi: PropTypes.func.isRequired,
    ativo: PropTypes.object.isRequired,
};

export default AtivosForm;


// WEBPACK FOOTER //
// ./src/components/ativos/AtivosForm.js